import * as z from 'zod';

export const skillFormSchema = z.object({
  Name: z.string().trim().min(1, { message: 'SKILL_NAME_REQUIRED' }),
  SubCategoryId: z.string().min(1, { message: 'SUB_CATEGORY_REQUIRED' }),
});

export type SkillFormValues = z.infer<typeof skillFormSchema>;
